import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { VIDEO_CALL_STATUS, VideoCallId } from '../../../video-conference/models/video-call';
import { VideoCallsActions } from '../../../video-conference/store/actions/videoCall';
import { Timestamp } from '../../common.types';
import { UISocketDataMessage } from '../../models/UISocket';
import { UserId } from '../../models/User';
import { VideoCallEventBase } from '../../models/VideoCallEventBase';
import { AppState } from '../../store/app-state';
import { SocketAction, SocketActionHandler } from '../SocketActionHandler';

export interface UISocketVideoCallInvitationSentEventMessage extends UISocketDataMessage, VideoCallEventBase {
    callId: VideoCallId;
    userId: UserId;
    createdAt: Timestamp;
    url: string;
    ownerToken: string;
}

@Injectable()
export class VideoCallInvitationSentHandler implements SocketActionHandler {
    readonly action: SocketAction = 'invitationSent';

    constructor(private store: Store<AppState>) {}

    handle(event: UISocketVideoCallInvitationSentEventMessage): void {
        this.store.dispatch(
            VideoCallsActions.videoCallInvitationSent({
                siteId: event.siteId,
                videoCall: {
                    id: event.callId,
                    companyId: event.companyId,
                    siteId: event.siteId,
                    installerId: event.userId,
                    createdAt: event.createdAt,
                    url: event.url,
                    ownerToken: event.ownerToken,
                    status: VIDEO_CALL_STATUS.INVITATION_SENT,
                },
            }),
        );
    }
}
